import { render } from "./PrinterSettingsButton.vue?vue&type=template&id=4d543555"
import script from "./PrinterSettingsButton.vue?vue&type=script&lang=js"
export * from "./PrinterSettingsButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__